
import React from "react";
import { Elements } from "../../../shared";
import { CacheManager, Utils } from "../../../../utils";
import { IPlatform, IProfile } from "../../../../services";

export interface DataProps {
    search: string;
    profile: IProfile;
    platform?: IPlatform;
}

function Data(props: DataProps) {
    const loading = !props.platform;
    const [postMessageKey, _] = React.useState(Utils.randomString(40));


    React.useEffect(() => {
        if (!props.platform) return;
        const accessHeaderMessageListener = (event: any) => {
            if (event.data.type === "BDS_BUS_REQUEST" && event.ports[0]) {
                const payload = JSON.parse(event.data.payload);
                if (payload.key !== postMessageKey) {
                    console.warn("Received an invalid key for access");
                    return;
                }
                const replyPort = event.ports[0];
                if (payload.action === "REQUEST_HEADER") {
                    replyPort.postMessage({
                        Authorization: "Bearer " + CacheManager.get(CacheManager.ACCESS_TOKEN_KEY)
                    });
                    return;
                }
            }
        };

        const script = document.createElement('script');
        script.async = true;
        script.id = "bds-script-id";
        script.src = "https://barmoury.github.io/barmoury-data-studio/bds.js?" + (new URLSearchParams({
            postmessagekey: postMessageKey,
            frameid: "data-studio-component",
            databases: `${props.platform.bacuator_data.database_schema}`,
            queryroute: `${props.platform.bacuator_data.location}${props.platform.bacuator_data.database_query_route}`,
        })).toString()
        window.addEventListener("message", accessHeaderMessageListener);
        document.body.appendChild(script);

        return () => {
            window.removeEventListener("message", accessHeaderMessageListener);
            const scriptToRemove = document.getElementById("bds-script-id");
            if (scriptToRemove) {
                document.body.removeChild(scriptToRemove);
            }
        };
    }, [props]);

    if (loading) {
        return (<div className="content management-links" style={{ padding: "30%" }}>
            {Elements.LOADING_STATE}
        </div>);
    }

    return (<iframe style={{ height: "100%", width: "100%", border: "none", outline: "none" }} id="data-studio-component"></iframe>);
}

export default Data;
